import { NgModule } from '@angular/core';
import { AirportNameI18nPipe } from './airport-name-i18n.pipe';

@NgModule({
  declarations: [AirportNameI18nPipe],
  providers: [],
  imports: [],
  exports: [AirportNameI18nPipe],
})
export class AirportNameI18nPipeModule {}
